import { getTemplate } from "../template-helper";
import { tr } from "../../util/locales";
import PDFObject from "pdfobject" ;

const COMPONENT_NAME = "z-media";

const TEMPLATE_ID = "component-" + COMPONENT_NAME + "-template";
const TEMPLATE_URL = "/static/libs/components/" + COMPONENT_NAME + ".html";

//https://stackoverflow.com/questions/14672746/how-to-compress-an-image-via-javascript-in-the-browser

// From https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob, needed for Safari:
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function(callback, type, quality) {

            var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
                len = binStr.length,
                arr = new Uint8Array(len);

            for (var i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], {type: type || 'image/png'}));
        }
    });
}

window.URL = window.URL || window.webkitURL;

// Modified from https://stackoverflow.com/a/32490603, cc by-sa 3.0
// -2 = not jpeg, -1 = no data, 1..8 = orientations
function getExifOrientation(file, callback) {
    // Suggestion from http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/:
    if (file.slice) {
        file = file.slice(0, 131072);
    } else if (file.webkitSlice) {
        file = file.webkitSlice(0, 131072);
    }

    var reader = new FileReader();
    reader.onload = function(e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8) {
            callback(-2);
            return;
        }
        var length = view.byteLength, offset = 2;
        while (offset < length) {
            var marker = view.getUint16(offset, false);
            offset += 2;
            if (marker == 0xFFE1) {
                if (view.getUint32(offset += 2, false) != 0x45786966) {
                    callback(-1);
                    return;
                }
                var little = view.getUint16(offset += 6, false) == 0x4949;
                offset += view.getUint32(offset + 4, little);
                var tags = view.getUint16(offset, little);
                offset += 2;
                for (var i = 0; i < tags; i++)
                    if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                        callback(view.getUint16(offset + (i * 12) + 8, little));
                        return;
                    }
            }
            else if ((marker & 0xFF00) != 0xFF00) break;
            else offset += view.getUint16(offset, false);
        }
        callback(-1);
    };
    reader.readAsArrayBuffer(file);
}

// Derived from https://stackoverflow.com/a/40867559, cc by-sa
function imgToCanvasWithOrientation(img, rawWidth, rawHeight, orientation) {
    var canvas = document.createElement('canvas');
   /* if (orientation > 4) {
        canvas.width = rawHeight;
        canvas.height = rawWidth;
    } else {*/
        canvas.width = rawWidth;
        canvas.height = rawHeight;
    //}

    if (orientation > 1) {
        console.log("EXIF orientation = " + orientation + ", rotating picture");
    }

    var ctx = canvas.getContext('2d');
    /*switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, rawWidth, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, rawWidth, rawHeight); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, rawHeight); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, rawHeight, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, rawHeight, rawWidth); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, rawWidth); break;
    }*/
    ctx.drawImage(img, 0, 0, rawWidth, rawHeight);
    return canvas;
}

function reduceFileSize(file, acceptFileSize, maxWidth, maxHeight, quality, callback) {
    if (file.size <= acceptFileSize) {
        callback(file);
        return;
    }
    var img = new Image();
    img.onerror = function() {
        URL.revokeObjectURL(this.src);
        callback(file);
    };
    img.onload = function() {
        URL.revokeObjectURL(this.src);
        getExifOrientation(file, function(orientation) {
            var w = img.width, h = img.height;
            var scale = (orientation > 4 ?
                Math.min(maxHeight / w, maxWidth / h, 1) :
                Math.min(maxWidth / w, maxHeight / h, 1));
            h = Math.round(h * scale);
            w = Math.round(w * scale);

            var canvas = imgToCanvasWithOrientation(img, w, h, orientation);
            canvas.toBlob(function(blob) {
                console.log("Resized image to " + w + "x" + h + ", " + (blob.size >> 10) + "kB");
                callback(blob);
            }, 'image/jpeg', quality);
        });
    };
    img.src = URL.createObjectURL(file);
}


export default function register() {
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template) => {

        class MediaComponent extends HTMLElement {
            constructor() {
                super();
                this.chosenFile = null;
                this.currentFile = null;
                this.originalFile = null;
            }

            connectedCallback() {
                this.chosenFile = null;
                this.currentFile = null;
                this.init();
            }

            init() {
                this.divView = this.querySelector(".z-media-view");
                if(!this.divView){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }

                this.inputHidden = this.querySelector("input.z-media-hidden");
                this.input = this.querySelector("input.z-media-fileopen");
                this.input.addEventListener('change', (ev) => {
                    this.chosenFile = this.input.files[0];

                    if(this.chosenFile && this.hasAttribute("z-media-max-width") && this.hasAttribute("z-media-max-size")){
                        ev.stopPropagation();
                        ev.preventDefault() ;
                        reduceFileSize(this.chosenFile, Number(this.getAttribute("z-media-max-size")), Number(this.getAttribute("z-media-max-width")), Infinity, 
                        Number(this.getAttribute("z-media-jpeg-quality")||0.8), blob => {
                            this.chosenFile = new File([blob], this.chosenFile.name, {type: "image/jpeg"});
                            this.chosenFile.url = URL.createObjectURL(this.chosenFile);
                            this.inputHidden.value="file";
                            this.renderWidget();
                            this.dispatchEvent(new Event('change', {bubbles: true}));
                        });
                    }else{
                        if(this.chosenFile){
                            this.chosenFile.url = URL.createObjectURL(this.chosenFile);
                            this.inputHidden.value="file";
                        }else{
                            this.inputHidden.value="";
                        }
                        this.renderWidget();
                    }

                });

                this.divView = this.querySelector(".z-media-view");
                this.imageElement = this.querySelector(".z-media-image");
                this.divViewImage = this.querySelector(".z-media-view-image");

                this.divViewSound = this.querySelector(".z-media-view-sound");
                this.audioElement = this.querySelector("audio");
                this.divViewSoundSource = this.querySelector(".z-media-view-sound source");

                this.divViewVideo = this.querySelector(".z-media-view-video");
                this.videoElement = this.querySelector("video");
                this.divViewVideoSource = this.querySelector(".z-media-view-video source");
                
                this.divViewPdf = this.querySelector(".z-media-view-pdf");
                this.pdfElement = this.querySelector("embed");

                this.divInput = this.querySelector(".z-media-input");
                this.divFilenamePicker = this.querySelector(".z-media-picker");
                this.filenameElement = this.querySelector(".z-media-filename");

                this.buttonOpenFile = this.querySelector(".z-media-btn-open");
                this.buttonOpenFile.addEventListener("click", () => {
                    this.input.click();
                });

                this.buttonClear = this.querySelector(".z-media-btn-clear");
                this.buttonClear.addEventListener("click", () => {
                    this.imageElement.src = null;

                    this.audioElement.pause();
                    this.divViewSoundSource.src = null;
                    
                    this.videoElement.pause();
                    this.divViewVideoSource.src = null;

                    this.pdfElement.src = null;

                    this.input.value = null;
                    this.chosenFile = null;
                    this.currentFile = null;
                    this.inputHidden.value = "" ;

                    this.dispatchEvent(new Event("change", { bubbles: true }));
                    this.renderWidget();
                });

                this.buttonUndo = this.querySelector(".z-media-btn-undo");
                this.buttonUndo.addEventListener("click", ()=>{
                    this.chosenFile = null;
                    this.currentFile = this.originalFile;
                    if(this.currentFile){
                        this.inputHidden.value = "file" ;
                    }else{
                        this.inputHidden.value = "" ;
                    }
                    this.dispatchEvent(new Event("change", { bubbles: true }));
                    this.renderWidget();
                });


                this.renderWidget();
            }

            

            renderWidget() {
                if (!this.divView) { return; }
                if (this.chosenFile) {
                    if (/^image/.test(this.chosenFile.type)) {
                        this.divViewImage.classList.remove("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                        this.imageElement.src = URL.createObjectURL(this.chosenFile);
                    } else if (/^audio/.test(this.chosenFile.type)) {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.remove("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                        this.divViewSoundSource.src = URL.createObjectURL(this.chosenFile);
                        this.divViewSoundSource.type = this.chosenFile.type;
                        this.audioElement.load();
                    } else if (/^video/.test(this.chosenFile.type)) {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.remove("d-none");
                        this.divViewPdf.classList.add("d-none");
                        this.divViewVideoSource.src = URL.createObjectURL(this.chosenFile);
                        this.divViewVideoSource.type = this.chosenFile.type;
                        this.videoElement.load();
                    } else if (this.chosenFile.type === "application/pdf") {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.remove("d-none");
                        // PDFObject.embed(URL.createObjectURL(this.chosenFile), this.divViewPdf);
                        this.pdfElement.src = URL.createObjectURL(this.chosenFile);
                        this.videoElement.load();
                    } else  {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                    }
                    this.divView.classList.remove("d-none");
                    this.filenameElement.setAttribute("placeholder", this.chosenFile.name);
                } else if (this.currentFile) {
                    if(this.currentFile instanceof File) {
                        this.currentFile.mimetype = this.currentFile.type;
                        this.currentFile.url = window.URL.createObjectURL(this.currentFile);
                        this.currentFile.filename = this.currentFile.name;
                    }
                    if (/^image/.test(this.currentFile.mimetype)) {
                        this.divViewImage.classList.remove("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                        this.imageElement.src = this.currentFile.url;
                    } else if (/^audio/.test(this.currentFile.mimetype)) {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.remove("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                        if (this.divViewSoundSource.src !== this.currentFile.url) {
                            this.divViewSoundSource.src = this.currentFile.url;
                            this.divViewSoundSource.type = this.currentFile.mimetype;
                            this.audioElement.load();
                        }
                    } else if (/^video/.test(this.currentFile.mimetype)) {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                        this.divViewVideo.classList.remove("d-none");
                        if (this.divViewVideoSource.src !== this.currentFile.url) {
                            this.divViewVideoSource.src = this.currentFile.url;
                            this.divViewVideoSource.type = this.currentFile.mimetype;
                            this.videoElement.load();
                        }
                    } else if (this.currentFile.mimetype === "application/pdf") {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewPdf.classList.remove("d-none");
                        this.divViewVideo.classList.add("d-none");
                        if(this.pdfElement.src){
                            this.pdfElement.src = "" ;
                            setTimeout(function(){
                                this.pdfElement.src = this.currentFile.url_inline;
                            }.bind(this), 10) ;
                        }else{
                            this.pdfElement.src = this.currentFile.url_inline;
                        }
                        // if (this.pdfElement.src !== this.currentFile.url_inline) {
                        // }
                        //PDFObject.embed(this.currentFile.url_inline, this.divViewPdf);
                    } else  {
                        this.divViewImage.classList.add("d-none");
                        this.divViewSound.classList.add("d-none");
                        this.divViewVideo.classList.add("d-none");
                        this.divViewPdf.classList.add("d-none");
                    }
                    this.divView.classList.remove("d-none");
                    this.filenameElement.setAttribute("placeholder", this.currentFile.filename);
                } else {
                    this.filenameElement.setAttribute("placeholder", tr("form.noMedia"));
                    this.divView.classList.add("d-none");
                }

                if (this.chosenFile === null && this.originalFile === this.currentFile) {
                    this.buttonUndo.setAttribute("disabled", "disabled");
                } else {
                    this.buttonUndo.removeAttribute("disabled");
                }

                if (this.chosenFile || this.currentFile) {
                    this.buttonClear.removeAttribute("disabled", "true");
                } else {
                    this.buttonClear.setAttribute("disabled", "disabled");
                }

                if (this.hasAttribute("readonly")) {
                    this.divInput.style = "display: none!important";
                } else {
                    this.divInput.style = "";
                }

                if (this.required) {
                    this.inputHidden.required = true;
                }
                if(this.hasAttribute('accept')) {
                    this.input.setAttribute('accept', this.getAttribute('accept')) ;
                } else {
                    this.input.removeAttribute('accept') ;
                }
            }

            get required() {
                return this.hasAttribute("required");
            }

            set required(required) {
                if(required){
                    this.setAttribute('required', required);
                }else{
                    this.removeAttribute('required');
                }
            }

            get value() {
                if (this.chosenFile) {
                    return this.chosenFile;
                }
                return this.currentFile;
            }

            set value(value) {
                this.originalFile = value? value : null;
                this.currentFile = value? value : null;
                this.chosenFile = null ;
                this.input.value = null;
                if(this.currentFile){
                    this.inputHidden.value="file";
                }else{
                    this.inputHidden.value="";
                }
                if(value && !value.url){
                    value.url = URL.createObjectURL(value);
                }
                this.renderWidget();
            }

            static get observedAttributes() {
                return ['readonly', "required"];
            }

            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.inputHidden){
                    this.inputHidden.setCustomValidity(msg) ;
                }
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'required':
                        this.renderWidget();
                        break;
                    case 'readonly':
                        this.renderWidget();
                        break;
                }
            }
        }
        customElements.define(COMPONENT_NAME, MediaComponent);
    }).catch((err) => {
        throw err;
    });
}
